import { format, isValid, parseISO } from 'date-fns'
import uk from 'date-fns/locale/uk'
import { PROMO_SCHEDULE_STATUS_LABELS, DEFAULT_PROMO_SOURCE } from './promoScheduleConstants'
import { getPromoScheduleStatus } from './getPromoScheduleStatus'

const formatPromoDate = (value) => {
  if (!value) {
    return null
  }

  const parsed = parseISO(value)

  if (!isValid(parsed)) {
    return value
  }

  return format(parsed, 'dd.MM.yyyy', { locale: uk })
}

export const formatPromoDateRange = (startDate, endDate) => {
  const startLabel = formatPromoDate(startDate)
  const endLabel = formatPromoDate(endDate)

  if (startLabel && endLabel) {
    return `${startLabel} – ${endLabel}`
  }

  if (startLabel) {
    return `з ${startLabel}`
  }

  if (endLabel) {
    return `до ${endLabel}`
  }

  return ''
}

export const formatPromoScheduleOption = (schedule, now = new Date()) => {
  const status = getPromoScheduleStatus(schedule, now)
  const title = schedule.cashboxScheduleName?.trim() || `Промо #${schedule.id}`
  const startDate = schedule.startedAt ?? null
  const endDate = schedule.finishedAt ?? null

  return {
    id: schedule.id,
    title,
    startDate,
    endDate,
    source: schedule.source ?? DEFAULT_PROMO_SOURCE,
    brandId: schedule.brandId ?? null,
    label: title,
    status,
    statusLabel: PROMO_SCHEDULE_STATUS_LABELS[status] || '',
    dateRangeLabel: formatPromoDateRange(startDate, endDate),
  }
}

export default formatPromoScheduleOption
